import { useEffect, useState, useRef } from 'react'

interface WordSpan {
  word: string
  delay: number
}

const useAnimatedHero = (text: string, delay: number = 0) => {
  const [spans, setSpans] = useState<WordSpan[]>([])
  const subheadingRef = useRef<HTMLHeadingElement | null>(null)

  useEffect(() => {
    const words = text.split(' ')

    const bezierEaseOut = (t: number): number => {
      const points = [0.215, 0.61, 0.355, 1]
      return (
        (1 - t) * (1 - t) * (1 - t) * points[0] +
        3 * (1 - t) * (1 - t) * t * points[1] +
        3 * (1 - t) * (1 - t) * t * t * points[2] +
        t * t * t * points[3]
      )
    }

    const newSpans = words.map((word, i) => ({
      word: i < words.length - 1 ? word + '\xa0' : word,
      delay: delay + bezierEaseOut(i / (words.length - 1)) + 130 * i,
    }))

    setSpans(newSpans)
  }, [text, delay])

  return { spans, subheadingRef }
}

export default useAnimatedHero
